import React from "react";
import UserInfo from "app/auth/UserInfo";
import { distanceInWordsToNow, parse } from "date-fns";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "react-intl";
import { dateLocale } from "app/utils";

const Muted = styled.div.attrs({
  className: "pt-text-muted"
})`
  font-size: 0.857em;
`;

const CommentByline = props => {
  const {
    userId,
    creationDate,
    deleteLink,
    isCityOfficial,
    intl: { locale }
  } = props;
  const created = parse(creationDate);
  const displayCreated = distanceInWordsToNow(created, {
    locale: dateLocale[locale]
  });
  return (
    <Muted>
      {userId && (
        <span>
          <strong>
            <UserInfo userId={props.userId} isCityOfficial={isCityOfficial} />
          </strong>
        </span>
      )}{" "}
      {displayCreated}{" "}
      <FormattedMessage
        id="proposal.byline.date.ago"
        defaultMessage="ago {user}"
        values={{ user: "" }}
      />{" "}
      {deleteLink}
    </Muted>
  );
};

export default injectIntl(CommentByline);



// WEBPACK FOOTER //
// ./src/app/comments/CommentByline.js